(ns ui.view.transaction-process.cards.document-upload
  "Attachment-slot upload pieces (`slot-section`, `get-attachments`,
   `upload-file!`) reused by the generic field card to render
   `:data.type/attachment-slot` fields."
  (:require
   [cljs.core.async :as async]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [frontend.logging :as logging]
   [oops.core :as oops]
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]
   [ui.view.transaction-process.components.file-upload :as file-upload]))

(defn- upload-file!
  [{:keys [file process-id slot-id uploading-atom]}]
  (let [filename     (oops/oget file "name")
        prog-channel (async/chan)
        remove-entry (fn [ups]
                       (vec (remove #(and (= (:filename %) filename)
                                          (= (:slot-id %) slot-id))
                                    ups)))]
    (swap! uploading-atom conj {:filename filename :slot-id slot-id})
    (common-actions/*<-create-op-token
     nil
     (fn [token]
       (attachment-actions/*=>add-attachment
        {:multipart-params (cond-> {:filename    filename
                                    :description nil
                                    :file        file
                                    :target      process-id
                                    :token       token}
                             slot-id
                             (assoc :system-kws (pr-str #{slot-id})))
         :progress         prog-channel}
        (fn [_resp]
          (swap! uploading-atom remove-entry))
        (fn [err]
          (swap! uploading-atom remove-entry)
          (logging/error "Upload failed" err))))
     (fn [err]
       (swap! uploading-atom remove-entry)
       (logging/error "Token creation failed" err)))))

(defn get-attachments
  [entity-data]
  (->> (:common/attachments entity-data)
       (map (fn [ref]
              (let [eid (or (:db/id ref) ref)]
                @(rf/subscribe [::session-sub/entity eid]))))
       (remove nil?)
       (remove :common/disabled?)
       (sort-by :attachment/uploaded-on)
       vec))

(defn slot-section
  [{:keys [slot-id slot-label mandatory? multiple? attachments process-id read-only? uploading-atom]}]
  (let [slot-uploads    (filterv #(= (:slot-id %) slot-id) @uploading-atom)
        show-drop-zone? (and (not read-only?)
                             (or multiple?
                                 (and (empty? attachments) (empty? slot-uploads))))]
    [:div {:class "mb-4"}
     [:h4 {:class "text-sm m-0 font-medium text-gray-700 mb-2"}
      slot-label
      (when mandatory?
        [:span {:class "ml-1 text-danger-light-text font-bold"} "*"])]
     [file-upload/attachments-list
      {:attachments attachments
       :target-id   process-id
       :read-only?  read-only?}]
     [file-upload/uploads-in-progress {:files slot-uploads}]
     (when show-drop-zone?
       [file-upload/drop-zone
        {:multiple? multiple?
         :on-files  (fn [files]
                      (doseq [file files]
                        (upload-file! {:file           file
                                       :process-id     process-id
                                       :slot-id        slot-id
                                       :uploading-atom uploading-atom})))}])]))
